import React from 'react';

import { PageTitle } from '../../components/PageTitle';
import { TransportOrdersFeed } from '../transport-orders-feed/TransportOrdersFeed';
import { useLoggedInUser } from '../users/LoggedInUserProvider';
import { DispatcherProfit } from './DispatcherProfit';

export const Home = () => {
    const { loggedInUser } = useLoggedInUser();

    return <>
        <PageTitle className="mb-0">
            Witaj, {loggedInUser.firstName}!
        </PageTitle>
        <DispatcherProfit />
        <TransportOrdersFeed />
    </>;
};
